import { depx as i } from "./ghl-ui.es770.js";
import { formatLength as r } from "./ghl-ui.es1008.js";
const d = 40, u = 40;
function p(e) {
  if (e.type === "selection")
    return e.width === void 0 ? d : i(e.width);
  if (e.type === "expand")
    return e.width === void 0 ? u : i(e.width);
  if (!("children" in e))
    return typeof e.width == "string" ? i(e.width) : e.width;
}
function l(e) {
  var n, t;
  if (e.type === "selection")
    return r((n = e.width) !== null && n !== void 0 ? n : d);
  if (e.type === "expand")
    return r((t = e.width) !== null && t !== void 0 ? t : u);
  if (!("children" in e))
    return r(e.width);
}
function y(e) {
  return e.type === "selection" ? "__n_selection__" : e.type === "expand" ? "__n_expand__" : e.key;
}
function _(e) {
  return e && (typeof e == "object" ? Object.assign({}, e) : e);
}
function g(e) {
  return e === "ascend" ? 1 : e === "descend" ? -1 : 0;
}
function O(e, n, t) {
  return t !== void 0 && (e = Math.min(e, typeof t == "number" ? t : parseFloat(t))), n !== void 0 && (e = Math.max(e, typeof n == "number" ? n : parseFloat(n))), e;
}
function c(e, n) {
  if (n !== void 0)
    return {
      width: n,
      minWidth: n,
      maxWidth: n
    };
  const t = l(e), { minWidth: s, maxWidth: o } = e;
  return {
    width: t,
    minWidth: r(s) || t,
    maxWidth: r(o)
  };
}
function w(e, n, t) {
  return typeof t == "function" ? t(e, n) : t || "";
}
function C(e) {
  return e.filterOptionValues !== void 0 || e.filterOptionValue === void 0 && e.defaultFilterOptionValues !== void 0;
}
function b(e) {
  return "children" in e ? !1 : !!e.sorter;
}
function x(e) {
  return "children" in e && e.children.length ? !1 : !!e.resizable;
}
function W(e) {
  return "children" in e ? !1 : !!e.filter && (!!e.filterOptions || !!e.renderFilterMenu);
}
function f(e) {
  if (e) {
    if (e === "descend")
      return "ascend";
  } else
    return "descend";
  return !1;
}
function F(e, n) {
  return e.sorter === void 0 ? null : n === null || n.columnKey !== e.key ? {
    columnKey: e.key,
    sorter: e.sorter,
    order: f(!1)
  } : Object.assign(Object.assign({}, n), { order: f(n.order) });
}
function m(e, n) {
  return n.find((t) => t.columnKey === e.key && t.order) !== void 0;
}
export {
  u as EXPAND_COL_WIDTH,
  d as SELECTION_COL_WIDTH,
  O as clampValueFollowCSSRules,
  c as createCustomWidthStyle,
  F as createNextSorter,
  w as createRowClassName,
  _ as createShallowClonedObject,
  y as getColKey,
  g as getFlagOfOrder,
  p as getNumberColWidth,
  l as getStringColWidth,
  W as isColumnFilterable,
  x as isColumnResizable,
  b as isColumnSortable,
  m as isColumnSorting,
  C as shouldUseArrayInSingleMode
};
